// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2t8T6","title":"ClientReferral_title__1KMdX","itemText":"ClientReferral_itemText__2Gj5F"};